import React from 'react'
import { Link } from 'react-router-dom'

export default props => (
    <li className="nav-item">
        <Link to={props.path} className={`nav-link ${props.active ? 'active' : ''}`} style={{ padding: 0 }}>
            <p 
                style={{ 
                    color: '#ffffff',
                    backgroundColor: props.active ? '#2785c4' : null,
                    fontWeight: 'bold',
                    fontSize: 18,
                    textAlign: 'center',
                    padding: 12
                }}>
				{props.label}
				<span class={`badge badge-${props.spanType} right`}>{props.span}</span>
			</p>
        </Link>
    </li>
)
